import request from '../request'
//司机台账 - 列表
export function driverbookList(data,pageNum,pageSize,start,end) {
    return request({
        url: `/driverbook/list?pageNum=${pageNum}&pageSize=${pageSize}&start=${start}&end=${end}`,
        method: "post",
        data
    })  
}
//司机台账 - 保存
export function driverbookSave(params,data) {
    return request({
        url: "/driverbook/save",
        method: "post",
        params,
        data
    })  
}
//司机台账 - 审核
export function driverbookExamine(params,data) {
    return request({
        url: "/driverbook/examine",
        method: "post",
        params,
        data
    })  
}
//司机台账 - 修改
export function driverbookUpdate(params,data) {
    return request({
        url: "/driverbook/update",
        method: "post",
        params,
        data
    })  
}
//司机台账 - 删除,只能删除审核拒绝的 & 自己的
export function driverbookDelete(id) {
    return request({
        url: `/driverbook/delete/${id}`,
        method: "get"
    })  
}
//销售台账 - 列表
export function saleList(data,pageNum,pageSize,start,end) {
    return request({
        url: `/sale/list?pageNum=${pageNum}&pageSize=${pageSize}&start=${start}&end=${end}`,
        method: "post",
        data
    })  
}
//销售台账 - 保存
export function saleSave(params,data) {
    return request({
        url: "/sale/save",
        method: "post",
        params,
        data
    })  
}
//销售台账 - 审核
export function saleExamine(params,data) {
    return request({
        url: "/sale/examine",
        method: "post",
        params,
        data
    })  
}
//销售台账 - 修改
export function saleUpdate(params,data) {
    return request({
        url: "/sale/update",
        method: "post",
        params,
        data
    })  
}
//销售台账 - 删除,只能删除审核拒绝的 & 自己的
export function saleDelete(id) {
    return request({
        url: `/sale/delete/${id}`,
        method: "get",   
    })  
}
//销售台账 - excel批量上传
export function saveBatch(params,data) {
    return request({
        url: `/sale/save/batch`,
        method: "post",
        params,
        data
    })  
}
//砂石自购台账 - 列表
export function stonepurchaseList(data,pageNum,pageSize,start,end) {
    return request({
        url: `/stonepurchase/list?pageNum=${pageNum}&pageSize=${pageSize}&start=${start}&end=${end}`,
        method: "post",
        data
    })  
}
//砂石自购台账 - 保存
export function stonepurchaseSave(params,data) {
    return request({
        url: "/stonepurchase/save",
        method: "post",
        params,
        data
    })  
}
//砂石自购台账 - 审核
export function stonepurchaseExamine(params,data) {
    return request({
        url: "/stonepurchase/examine",
        method: "post",
        params,
        data
    })  
}
//砂石自购台账 - 修改
export function stonepurchaseUpdate(params,data) {
    return request({
        url: "/stonepurchase/update",
        method: "post",
        params,
        data
    })  
}
//砂石自购台账 - 删除,只能删除审核拒绝的 & 自己的
export function stonepurchaseDelete(id) {
    return request({
        url: `/stonepurchase/delete/${id}`,
        method: "get",
    })  
}
//柴油入库 - 查询列表,查询全部的
export function oilinList(data,pageNum,pageSize) {
    return request({
        url: `/oilin/list/all?pageNum=${pageNum}&pageSize=${pageSize}`,
        method: "post",
        data
    })  
}
//柴油入库 - 保存
export function oilinSave(params,data) {
    return request({
        url: "/oilin/save",
        method: "post",
        params,
        data
    })  
}
//柴油入库 - 修改
export function oilinUpdate(params,data) {
    return request({
        url: "/oilin/update",
        method: "post",
        params,
        data
    })  
}
//柴油入库 - 删除,只能删除审核拒绝的 & 自己的
export function oilinDelete(id) {
    return request({
        url: `/oilin/delete/${id}`,
        method: "get",
    })  
}